import { graphql } from '@eluve/graphql.tada';

export const searchTenantUsersInvitesQuery = graphql(`
  query searchTenantUsersInvites(
    $filter: CombinedTenantUsersInvitesBoolExp
    $offset: Int
    $orderBy: [CombinedTenantUsersInvitesOrderBy!]
    $limit: Int
  ) {
    combinedTenantUsersInvites(
      where: $filter
      offset: $offset
      limit: $limit
      orderBy: $orderBy
    ) {
      __typename
      inviteId
      userId
      firstName
      lastName
      email
      status
      role
      createdAt
      lastAccessedAt
      isExpired
      isExcluded
      lifecycleStatus
    }
    combinedTenantUsersInvitesAggregate(where: $filter) {
      aggregate {
        count
      }
    }
  }
`);

export const getTenantMemberQuery = graphql(`
  query GetTenantMember($filter: CombinedTenantUsersInvitesBoolExp) {
    combinedTenantUsersInvites(where: $filter, limit: 1) {
      __typename
      userId
      firstName
      lastName
      email
      role
      createdAt
      lastAccessedAt
      isExcluded
      lifecycleStatus
    }
  }
`);

export const getMemberLocationsQuery = graphql(`
  query GetMemberLocations($tenantId: uuid!, $userId: uuid!) {
    locationUsers(
      where: { tenantId: { _eq: $tenantId }, userId: { _eq: $userId } }
      orderBy: { location: { name: ASC } }
    ) {
      __typename
      locationId
      userId
      location {
        __typename
        id
        name
      }
    }
  }
`);

export const removeTenantUserMutation = graphql(`
  mutation RemoveTenantUser($tenantId: uuid!, $userId: uuid!) {
    deleteTenantUsersByPk(tenantId: $tenantId, userId: $userId) {
      __typename
      tenantId
      userId
    }
  }
`);

export const setTenantUserExcludedMutation = graphql(`
  mutation SetTenantUserExcluded(
    $tenantId: uuid!
    $userId: uuid!
    $isExcluded: Boolean!
  ) {
    updateTenantUsersByPk(
      pkColumns: { tenantId: $tenantId, userId: $userId }
      _set: { isExcluded: $isExcluded }
    ) {
      __typename
      tenantId
      userId
      isExcluded
    }
  }
`);

export const updateTenantUserRoleMutation = graphql(`
  mutation UpdateUserTenantRole(
    $tenantId: uuid!
    $userId: uuid!
    $role: String!
  ) {
    updateTenantUsersByPk(
      pkColumns: { tenantId: $tenantId, userId: $userId }
      _set: { role: $role }
    ) {
      __typename
      tenantId
      userId
      role
    }
  }
`);
